'use strict';

wbApp.factory('newsSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        const News = $resource('/restapi/news/:id', {}, {
            'getById': {method: 'GET', url: '/restapi/news/:id'},
            'getAll': {method: 'GET', isArray: true, url: '/restapi/news/info'},
            'insert': {method: 'POST', url: '/restapi/news'},
            'update': {method: 'PUT', url: '/restapi/news/:id'},
            'delete': {method: 'DELETE', url: '/restapi/news/:id'}
        });

        let news;

        function createNew()
        {
            return {
                id: null,
                title: null,
                subTitle: null,
                publishedAtUtc: new Date(),
                isVisibleToClients: false,
                body: null,
                pictureUrls: null
            };
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                News,
                model);
        }

        function remove(id) {
            news = null;
            return repositorySvc.customDelete(
                'delete',
                News,
                { id: id });
        }

        function update(model) {
            news = null;
            return repositorySvc.customPutWithParams(
                'update',
                News,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(id) {
            return repositorySvc.customGet('getById', News, { id: id });
        }

        function getAll(refresh) {
            if (!news || refresh) {
                news = repositorySvc.customGet('getAll', News, {});
            }
            return news;
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            insert: insert,
            remove: remove,
            update: update
        }
    }]);